import React, { PureComponent, Fragment } from "react";
import axios from "axios";
import { Portal } from "../Components/Portal";
import { Checkout } from "../Checkout/Checkout";
import AddToCart from "../ProductActions/AddToCart";
import withDataLayer from "../HOCs/withDataLayer";
import document from "global/document";

const AddToCartWithDataLayer = withDataLayer(AddToCart);

let addToCartPortalRoot, checkoutPortalRoot;

if (document.querySelector) {
    addToCartPortalRoot = document.querySelector("#product-actions");
}

if (document.querySelector) {
    checkoutPortalRoot = document.querySelector("#checkout");
}

class ShoppingCart extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showItems: false,
            isLoading: false,
            items: [],
            totalPrice: 0.0
        };
        this.fetchItems = this.fetchItems.bind(this);
        this.handleUpdateCart = this.handleUpdateCart.bind(this);
    }
    componentDidMount() {
        this.setState(
            {
                isLoading: true
            },
            this.fetchItems()
        );
    }
    fetchItems() {
        axios
            .get("/cart")
            .then(response => {
                let items = response.data.items;

                if (items) {
                    let prices = items.map(item => {
                        return item.price * item.qty;
                    });
                    let totalPrice = this.sum(prices);

                    this.setState({
                        items: items,
                        totalPrice: totalPrice,
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                }
            })
            .catch(err => {
                console.error(err);
                this.setState({
                    isLoading: false
                });
            });
    }
    render() {
        return (
            <Fragment>
                <svg
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    className="gHeader__cart__icon"
                >
                    <path
                        fill="currentColor"
                        d="M551.991 64H144.28l-8.726-44.608C133.35 8.128 123.478 0 112 0H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h80.24l69.594 355.701C150.796 415.201 144 430.802 144 448c0 35.346 28.654 64 64 64s64-28.654 64-64a63.681 63.681 0 0 0-8.583-32h145.167a63.681 63.681 0 0 0-8.583 32c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-18.136-7.556-34.496-19.676-46.142l1.035-4.757c3.254-14.96-8.142-29.101-23.452-29.101H203.76l-9.39-48h312.405c11.29 0 21.054-7.869 23.452-18.902l45.216-208C578.695 78.139 567.299 64 551.991 64zM208 472c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm256 0c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm23.438-200H184.98l-31.31-160h368.548l-34.78 160z"
                        className=""
                    />
                </svg>
                <div className="gHeader__cart__wrapper">
                    <span className="gHeader__cart__label">shopping cart</span>
                    <span className="gHeader__cart__text">
                        <span className="gHeader__cart__text__quantity">
                            {this.state.items.length}
                        </span>
                        <span className="gHeader__cart__text__items">{`item${
                            this.state.items.length != 1 ? "s" : ""
                        }`}</span>
                        <span className="gHeader__cart__text__price">
                            {`$${this.state.totalPrice.toFixed(2)}`}
                        </span>
                    </span>
                </div>
                {addToCartPortalRoot &&
                    (addToCartPortalRoot.dataset &&
                        (addToCartPortalRoot.dataset.quote_status == "0" && (
                            <Portal node="#product-actions">
                                <AddToCartWithDataLayer
                                    passHasAdded={this.handleUpdateCart}
                                    {...addToCartPortalRoot.dataset}
                                />
                            </Portal>
                        )))}
                {checkoutPortalRoot &&
                    (checkoutPortalRoot.dataset &&
                        (checkoutPortalRoot.dataset.cart && (
                            <Portal node="#checkout">
                                <Checkout
                                    initialCart={
                                        checkoutPortalRoot.dataset.cart
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .cart
                                            )
                                            : {}
                                    }
                                    initialTotals={
                                        checkoutPortalRoot.dataset.totals
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .totals
                                            )
                                            : []
                                    }
                                    initialSellers={
                                        checkoutPortalRoot.dataset.sellers
                                            ? JSON.parse(
                                                checkoutPortalRoot.dataset
                                                    .sellers
                                            )
                                            : []
                                    }
                                    isCustomer={
                                        checkoutPortalRoot.dataset.iscustomer
                                    }
                                    didFetch={() => this.handleUpdateCart()}
                                />
                            </Portal>
                        )))}
            </Fragment>
        );
    }
    handleUpdateCart() {
        this.fetchItems();
    }
    sum(arr) {
        let sum = 0;

        for (let item of arr) {
            sum += item;
        }
        return sum;
    }
}

export { ShoppingCart };
